import { useContext, useEffect, useState } from 'react';
import SelectInput from './SelectInput';
import { FormContext } from '../FormEngine';
import { getLLSFunds } from '../SpecialRules/LLSSpecialRules';
import { useAssistPointApiFetcher } from '../../Data/AssistPointApiFetcher';

//takes an onChange prop and calls it with (dataKey, newValue)
const LLSFundSelectInput = props => {
    const { dataKey, data, onChange } = props;

    const { fetchGET } = useAssistPointApiFetcher();
    const ctx = useContext(FormContext);

    const [funds, setFunds] = useState(null);
    const [filteredFunds, setFilteredFunds] = useState(null);

    const getFunds = async () => {
        const llsFunds = await getLLSFunds(fetchGET, ctx.meta.assistanceProgramId);

        if (!!llsFunds)
            setFunds(llsFunds);
    }

    useEffect(() => {
        getFunds();
        
    }, []);

    const checkValue = value => {
        if (filteredFunds) {
            let newValue = value;

            if (!filteredFunds.find(o => o.value === value)) {
                newValue = '';
            }

            onChange(dataKey, newValue);
        }
    }

    useEffect(() => {
        if (funds && funds.length > 0) {
            // find funds based on selected AssistanceService from application wizard
            // filter based on insurance selection
            var filt = funds
                .find(f => f.assistanceServiceId === ctx.meta.assistanceServices[0].id).funds
                .filter(f => {
                    const ins = ctx.formData['Insurance Patient Insurance Types LLS'];
                    return ins ? ins.includes(f.insuranceClassName) : true
                })
                .flatMap(f => f.funds);

            var fundOptions = [...new Set(filt)]
                .sort((a, b) => a < b ? -1 : 1)
                .map((fund, idx) => (
                    { key: `${fund}/${idx}`, value: fund, text: fund }
                ));

            setFilteredFunds(fundOptions);
        }

        checkValue(data);
        
    }, [funds, data]);

    if (!filteredFunds || filteredFunds.length === 0) { return null; }

    const myProps = {
        ...props,
        def: {
            ...props.def,
            options: filteredFunds.map(f => f.text),
            values: filteredFunds.map(f => f.value)
        },
        onChange: (dataKey, value) => {
            checkValue(value);
        },
        name: 'llsfundselectinput_de'
    }

    return <SelectInput {...myProps} />
}

export default LLSFundSelectInput;
